export const BRAND = {
  name: "Sasquatch Lighting Co.",
  shortName: "Sasquatch Lighting",
  gameName: "Roof Runner",
  phoneDisplay: import.meta.env.VITE_PHONE ?? "(865) 463-5742",
  phoneTel: import.meta.env.VITE_PHONE_TEL ?? "+18654635742",
  quoteUrl: import.meta.env.VITE_QUOTE_URL ?? "https://sasquatchlightingco.com",
  leadEmail: import.meta.env.VITE_LEAD_EMAIL ?? "nickmrichards@gmail.com",
  serviceLine: "Knoxville, Knox, Blount, and Sevier counties",
  veteran: "Veteran-owned",
} as const;

export function gameUrl(): string {
  const fromEnv = import.meta.env.VITE_GAME_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://sasquatchlightingco.com";
}

export const STORAGE = {
  bestScore: "slc-roof-runner-best-score",
  bestHouses: "slc-roof-runner-best-houses",
  localWeek: "slc-roof-runner-local-week",
  localLeads: "slc-roof-runner-local-leads",
} as const;
